{
  "version": 1,
  "asset_id": "2fa18e06-3cce-4c2e-b204-b1db82a7f5fb",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/2fa18e06-3cce-4c2e-b204-b1db82a7f5fb/offergeld-20230620.jpg",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/2fa18e06-3cce-4c2e-b204-b1db82a7f5fb/offergeld-20230620.jpg",
  "original_filename": "offergeld-20230620.jpg",
  "size": 420862,
  "content_type": "image/jpeg",
  "created_at": "2026-10-08T11:25:25Z"
}
